module.exports = __webpack_public_path__ + "30.99a79972.png";